module.exports = __webpack_public_path__ + "media/metronic/_theme/media/bg/bg-4-832a4d3ff41654d5d835bad73c2784d2.jpg";